/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Noageratings3Inputs */

const id_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada peringkat usia ditemukan`)
};

const ms_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada penarafan umur ditemui`)
};

const da_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aldersvurderinger fundet`)
};

const de_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Altersfreigaben gefunden`)
};

const en_us2_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

const es_es2_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron clasificaciones por edad`)
};

const es_mx2_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron clasificaciones por edad`)
};

const fil_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang rating ng edad`)
};

const fr_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune classification trouvée`)
};

const it_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna classificazione età trovata`)
};

const hu_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található korhatár besorolás`)
};

const nl_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen leeftijdsclassificaties gevonden`)
};

const no_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aldersvurderinger funnet`)
};

const pl_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono klasyfikacji wiekowych`)
};

const pt_br2_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma classificação etária encontrada`)
};

const pt_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma classificação etária encontrada`)
};

const ro_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit clasificări de vârstă`)
};

const fi_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikärajoja ei löytynyt`)
};

const sv_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga åldersklassificeringar hittades`)
};

const vi_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy xếp hạng độ tuổi`)
};

const tr_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş sınırı bulunamadı`)
};

const cs_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyla nalezena žádná věková hodnocení`)
};

const bg_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени възрастови ограничения`)
};

const ru_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастные рейтинги не найдены`)
};

const uk_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вікових рейтингів не знайдено`)
};

const ar_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على تصنيفات عمرية`)
};

const hi_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई आयु रेटिंग नहीं मिली`)
};

const th_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบเรตอายุ`)
};

const ja_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティングが見つかりません`)
};

const zh_cn2_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到年龄分级`)
};

const zh_hant1_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到年齡分級`)
};

const ko_offerdetail_overview_noageratings3 = /** @type {(inputs: Offerdetail_Overview_Noageratings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연령 등급을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No age ratings found" |
*
* @param {Offerdetail_Overview_Noageratings3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_noageratings3 = /** @type {((inputs?: Offerdetail_Overview_Noageratings3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Noageratings3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_noageratings3(inputs)
	if (locale === "ms") return ms_offerdetail_overview_noageratings3(inputs)
	if (locale === "da") return da_offerdetail_overview_noageratings3(inputs)
	if (locale === "de") return de_offerdetail_overview_noageratings3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_noageratings3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_noageratings3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_noageratings3(inputs)
	if (locale === "fil") return fil_offerdetail_overview_noageratings3(inputs)
	if (locale === "fr") return fr_offerdetail_overview_noageratings3(inputs)
	if (locale === "it") return it_offerdetail_overview_noageratings3(inputs)
	if (locale === "hu") return hu_offerdetail_overview_noageratings3(inputs)
	if (locale === "nl") return nl_offerdetail_overview_noageratings3(inputs)
	if (locale === "no") return no_offerdetail_overview_noageratings3(inputs)
	if (locale === "pl") return pl_offerdetail_overview_noageratings3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_noageratings3(inputs)
	if (locale === "pt") return pt_offerdetail_overview_noageratings3(inputs)
	if (locale === "ro") return ro_offerdetail_overview_noageratings3(inputs)
	if (locale === "fi") return fi_offerdetail_overview_noageratings3(inputs)
	if (locale === "sv") return sv_offerdetail_overview_noageratings3(inputs)
	if (locale === "vi") return vi_offerdetail_overview_noageratings3(inputs)
	if (locale === "tr") return tr_offerdetail_overview_noageratings3(inputs)
	if (locale === "cs") return cs_offerdetail_overview_noageratings3(inputs)
	if (locale === "bg") return bg_offerdetail_overview_noageratings3(inputs)
	if (locale === "ru") return ru_offerdetail_overview_noageratings3(inputs)
	if (locale === "uk") return uk_offerdetail_overview_noageratings3(inputs)
	if (locale === "ar") return ar_offerdetail_overview_noageratings3(inputs)
	if (locale === "hi") return hi_offerdetail_overview_noageratings3(inputs)
	if (locale === "th") return th_offerdetail_overview_noageratings3(inputs)
	if (locale === "ja") return ja_offerdetail_overview_noageratings3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_noageratings3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_noageratings3(inputs)
	return ko_offerdetail_overview_noageratings3(inputs)
});
export { offerdetail_overview_noageratings3 as "offerDetail.overview.noAgeRatings" }